import UICreatorGraphics from "@baseUI/utils/UICreatorGraphics";
import MenuPopupLayoutLandscape from "@baseUI/component/layout/MenuPopupLayoutLandscape";
import UIBaseView from "@baseUI/views/UIBaseView";

export default class MobileLandscapeView extends UIBaseView {

    constructor(uiModelView) {
        super(uiModelView)
    }

    setParametersSizePosition(){
        this.nameLayout = 'landscapeLayout'

        this.param = {
            widthPanel: this.uiModelView.widthScreen, //2600,
            panelButtonsPosition: {x: 0, y: 2200},
            spinBtn: { name: 'mobileSpinPortrait_BUTTON', position: [980, 100]},
            maxBetBtn: { name: 'mobileBet_BUTTON', position: [900, -135]},
            autoplayBtn: { name: 'mobileAutoplayPortrait_BUTTON', position: [1000, -300]},
            autoplayCounterBtnPosition: { name: 'mobileAutoplayStop_BUTTON', position: [1000, -300]},
            isBottomWatch: true,
            infoBtn: {name: 'mobileInfo_BUTTON'},
            menuBtn: {name: 'mobileMenu_BUTTON'},
            soundBtn: {name: 'mobileSound_STATE'}
        }
    }

    init(){
        super.init()
        this.menuPopup = new MenuPopupLayoutLandscape()
        this.addChild(this.menuPopup)
        this.menuPopup.hide()
    }

    createPanelTop(widthPanel) {}

    addSubstrateComponent(widthPanel, rectWidth){
        const xStart = -widthPanel / 2 - 50
        this.panelSubstrate.removeChildren()
        UICreatorGraphics.addRect(this.panelSubstrate, xStart, rectWidth + 3, widthPanel + 100, 2 * rectWidth + 3, 0x323031, 0.7)
        UICreatorGraphics.addLine(this.panelSubstrate, xStart, 2 * rectWidth + 3, widthPanel + 100, 2 * rectWidth + 3)
        UICreatorGraphics.addRect(this.panelSubstrate, xStart, 2 * rectWidth + 7, widthPanel + 100, 3 * rectWidth, 0x323031, 0.9)
    }

    setPositionComponents(widthPanel, rectWidth){
        this.soundBtn.position.set(-widthPanel/2 + 300, 260)
        this.infoBtn.position.set(-widthPanel/2 + 190, 260)
        this.menuBtn.position.set(-widthPanel/2 + 80, 260)

        this.gameNameText.position.set(widthPanel / 2 - 350, 260)
        this.watchText.position.set(widthPanel / 2 - 100, 260)
        this.rtpText.position.set(0, 260)

        this.activeBets.position.set( -widthPanel/2, rectWidth + 5)
        this.winText.position.set(this.gameNameText.x - 300, rectWidth + 80)
        this.winValue.position.set(this.winText.x, this.winText.y + 60)
        this.balanceText.position.set(this.soundBtn.x + 200, 260)
        this.balanceValue.position.set(this.balanceText.x + this.balanceText.width/2 + 20, this.balanceText.y)


    }

    update() {
        super.update()
        this.x = 1390
        this.y = 0//400 + window.app.stage.y / this.uiModelView.scale
        this.addSubstrateComponent( this.uiModelView.widthScreen, 110)
        this.setPositionComponents( this.uiModelView.widthScreen, 110)
        this.panelBottom.y = 2300 + this.uiModelView.shiftY
        this.panelButtons.y = 2200 + this.uiModelView.shiftY
        this.menuPopup.updateSize(this.uiModelView)
    }

}
